import loadable from '@loadable/component';

// Template
import RequiredTemplate from '../../components/required/RequiredTemplate';
import { DOCUMENT_CODE } from '../../components/documents/form/DocumentUtils';

const PATH = '/required';

const requiredRoutes = {
  name: 'required.root',
  path: PATH,
  component: RequiredTemplate,
  exact: false,
  requiredFeatures: [],
  routes: [
    {
      name: 'required.requiredLoginFields',
      path: `${PATH}/requiredLoginFields`,
      component: loadable(
        () => import('../../components/required/RequiredLoginFields'),
      ),
      requiredFeatures: [],
      exact: true,
      query: require('../../components/required/__generated__/RequiredLoginFieldsQuery.graphql'),
      queriesParams: () => ({
        documentType: DOCUMENT_CODE['BRA:PCD'],
      }),
    },
  ],
};

export default requiredRoutes;
